var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterception(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.75C10.4142 0.75 10.75 1.08579 10.75 1.5V22.5C10.75 22.9142 10.4142 23.25 10 23.25C9.58579 23.25 9.25 22.9142 9.25 22.5V1.5C9.25 1.08579 9.58579 0.75 10 0.75ZM5.5 3.75298C5.91421 3.75298 6.25 4.08877 6.25 4.50298V19.497C6.25 19.9112 5.91421 20.247 5.5 20.247C5.08579 20.247 4.75 19.9112 4.75 19.497V4.50298C4.75 4.08877 5.08579 3.75298 5.5 3.75298ZM14.5 3.75298C14.9142 3.75298 15.25 4.08877 15.25 4.50298V19.497C15.25 19.9112 14.9142 20.247 14.5 20.247C14.0858 20.247 13.75 19.9112 13.75 19.497V4.50298C13.75 4.08877 14.0858 3.75298 14.5 3.75298ZM1 6.75597C1.41421 6.75597 1.75 7.09176 1.75 7.50597V16.5151C1.75 16.9293 1.41421 17.2651 1 17.2651C0.585786 17.2651 0.25 16.9293 0.25 16.5151V7.50597C0.25 7.09176 0.585786 6.75597 1 6.75597ZM19 6.75597C19.4142 6.75597 19.75 7.09176 19.75 7.50597V16.5151C19.75 16.9293 19.4142 17.2651 19 17.2651C18.5858 17.2651 18.25 16.9293 18.25 16.5151V7.50597C18.25 7.09176 18.5858 6.75597 19 6.75597Z",
    fill: "#E3E6F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterception);
export default __webpack_public_path__ + "static/media/interception.1a1aa3933f1553e51075333fdd7f5572.svg";
export { ForwardRef as ReactComponent };